export default __webpack_public_path__ + "static/column-img-2-25f9cee8af88f4f7fa41125a7bd22f75.jpg";